import { render, staticRenderFns } from "./FixedOddsBingoCallerScreen.vue?vue&type=template&id=68cc113c&scoped=true&"
import script from "./FixedOddsBingoCallerScreen.vue?vue&type=script&lang=js&"
export * from "./FixedOddsBingoCallerScreen.vue?vue&type=script&lang=js&"
import style0 from "./FixedOddsBingoCallerScreen.vue?vue&type=style&index=0&id=68cc113c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc113c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VImg,VOverlay,VProgressCircular,VRow,VSheet,VSpacer,VTextField})
